
class portSetUpCtrl {
    constructor($scope, httpRequest, $state, $uibModal, $timeout, logger, sweetalert) {
        $scope.param = {
            dataType: 1,
            remark: '',
            callbackUrl: '',
            templateName: '',
            interfaceType: 'sys',
            interfaceName: '',
            interfaceCode: '',
            detailList: [],
            retryTime: '',
        }
        $scope.newList = []
        if ($state.current.name == 'system.settingcenter.portSetUp.detail') {
            $scope.isDetail = true
            httpRequest.get_getSysInterface($state.params.interfaceId).then((res) => {
                $scope.param = res.data.value
            })
        }
        if ($state.current.name == 'system.settingcenter.portSetUp.edit') {
            $scope.isEdit = true
            httpRequest.get_getSysInterface($state.params.interfaceId).then((res) => {
                $scope.param = res.data.value
                $scope.param.detailList.forEach((item) => {
                    if (item.isDefault == '0') {
                        item.originalField = '扩展'
                        $scope.newList.push(item)
                    }
                })
                $scope.param.detailList.forEach((o, i) => {
                    if (o.isDefault == '0') {
                        $scope.param.detailList.splice(i)
                    }
                })
            })
        }
        $scope.tabChange = function tabChange(v) {
            $scope.param.dataType = v
        }
        httpRequest.get_dictByTypeArr(['system_module']).then((res) => {
            $scope.dictData = res.data.value
        })
        $scope.openPop = function openPop() {
            $uibModal.open({
                templateUrl: 'add-port-modal.html',
                openedClass: 'mod-modal mod-modal-lg',
                controller: ['$scope', '$uibModalInstance', 'httpRequest', function ($scope, $uibModalInstance, httpRequest) {
                    $scope.cancel = () => {
                        $uibModalInstance.dismiss()
                    }
                    $scope.queryParam = {
                        pageSize: 10,
                        pageNum: 1,
                        param: {
                            interfaceType: 'ovat',
                            templateName: '',
                        },
                    }
                    $scope.tabChange = function tabChange(value) {
                        $scope.queryParam.param.interfaceType = value
                        $scope.queryList()
                    }
                    $scope.queryList = function queryList() {
                        httpRequest.post_getSysInterfaceTemplateList($scope.queryParam).then((res) => {
                            $scope.listData = res.data.value
                        })
                    }
                    $scope.queryList()
                    // 返回选中的对象
                    $scope.ok = (obj) => {
                        $uibModalInstance.close(obj)
                    }
                }],
                animation: true,
            }).result.then((obj) => {
                $scope.param.templateName = obj.templateName
                $scope.param.templateId = obj.templateId
                httpRequest.get_getSysInterfaceTemplate(obj.templateId).then((res) => {
                    $timeout(() => {
                        $scope.param.detailList = res.data.value.detailList
                        if (res.data.value.tempCode == '2003') $scope.param.callbackUrl = 'http://192.168.51.34:9999/verifyInvoicePush'
                        if (res.data.value.tempCode == '2002') $scope.param.callbackUrl = 'http://192.168.51.34:9999/authInvoicePush'
                    })
                })
            })
        }
        $scope.edit = function edit(obj, k) {
            obj[k] = false
        }
        $scope.addDetailList = function addDetailList() {
            if ($scope.newList.length > 19) {
                logger.logError('自定义字段最多只能新增20条')
                return
            }
            $scope.newList.push({
                remark: '自定义字段',
                targetField: '',
                isPrimary: '0',
                isAllowEmpty: '1',
                fieldLength: '32',
                fieldType: 'String',
                originalField: '扩展',
                isDefault: '0',
            })
            $scope.newList[$scope.newList.length - 1].isEditA = true
        }
        $scope.deleteItem = function deleteItem(index) {
            sweetalert.confirm('删除提醒', '确定删除自定义字段？').then(() => {
                $scope.newList.splice(index, 1)
            })
        }
        $scope.cancel = function cancel() {
            $state.go('system.settingcenter.portSetUp.list')
        }
        $scope.ok = function ok() {
            $scope.newList.forEach((item, index) => {
                item.originalField += (index + 1)
            })
            $scope.oldList = $scope.param.detailList
            $scope.param.detailList = $scope.param.detailList.concat($scope.newList)
            if (!$scope.isEdit) {
                httpRequest.post_addSysInterface($scope.param).then(() => {
                    logger.logSuccess('新增成功')
                    $state.go('system.settingcenter.portSetUp.list')
                }, () => {
                    $scope.newList.forEach((item) => {
                        item.originalField = '扩展'
                    })
                    $scope.param.detailList = $scope.oldList
                })
            } else {
                httpRequest.post_updateSysInterface($scope.param).then(() => {
                    logger.logSuccess('编辑成功')
                    $state.go('system.settingcenter.portSetUp.list')
                }, () => {
                    $scope.newList.forEach((item) => {
                        item.originalField = '扩展'
                    })
                    $scope.param.detailList = $scope.oldList
                })
            }
        }
        // 重复次数
        $scope.$watch('param.retryTime', (newVal, oldVal) => {
            if (new RegExp(/^[0-9]*$/g).test($scope.param.retryTime)) return
            $scope.param.retryTime = oldVal
        })
    }
}

portSetUpCtrl.$inject = ['$scope', 'httpRequest', '$state', '$uibModal', '$timeout', 'logger', 'sweetalert']
export default portSetUpCtrl



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/portSetUp/add.js